var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"save",on:{"click":_vm.save}},[_vm._v("保存")]),_c('div',{attrs:{"id":"tui-image-editor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }